import { useMemo } from 'react';
import { getTodayDate } from '@/creditflowresearch/application/BondScreener/getTodayDate';
import { createUseDateRangeFilter } from '@/creditflowresearch/ui/common/hooks/sidebar/useDateRangeFilter';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useDateRangeFilter = createUseDateRangeFilter(useCorporateBondScreenerSidebarFilterContext);

const useDateFilter = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();

  const bounds = useMemo(() => ({
    from: filters?.date?.from,
    to: getTodayDate(),
  }), [filters?.date]);

  return useDateRangeFilter({
    fromKey: 'dateFrom',
    toKey: 'dateTo',
    bounds,
  });
};

export default useDateFilter;
